import React, { Component } from 'react';
import moment from 'moment';
import Axios from 'axios';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import isNull from 'lodash/isNull';
import has from 'lodash/has';
import get from 'lodash/get';
import styled from 'styled-components';
import Toggle from 'react-toggle';

import Loading from '../../../../components/Loading';
import Colors from '../../../../styles/colors';
import {
  LoadingWrapper,
  ToggleWrapper,
  ToggleLabel,
} from '../../../../styles/styled';

import { couponsManager, publisherManager } from '../../../../helpers/managers';
import { ucfirst } from '../../../../helpers/texts';
import { STATIC_HOMEPAGE_URL } from '../../../../config';
import { OrangeSubmitButton, ActionButton } from '../../../../components/buttons/buttons';
import CustomDialog from '../custom_dialog';
import { TableContainer, Table, StatusContainer } from './styled';
import {
  getUsageCurrent,
  getUsageLimit,
  canUserAccessFeature,
} from '../../../../helpers/userinfoHelper';
const {
  isPublisherPlan,
  isPublisherReferredByPartner,
  isWithinDaysRange,
  getPartners,
  getPartnerCodes,
  getPartnerCodesValidity,
  getPlanStatus,
  getPublisherPlanInfo,
} = require('../../../../../server/scripts/utils')();

class Account extends Component {
  constructor(props) {
    super(props);
    this.state = {
      invoices: [],
      affiliate: false,
      couponText: '',
      fetchInvoices: false,
      privateSoundcastsUsageText: '',
      onlyMobileAccessToTracks: false,      // publisher prop
      disableTracksAttachedContent: false,  // publisher prop
      planCancelled: false,
    };

    this.handlePlanCancel = this.handlePlanCancel.bind(this);
    this.revokePlan = this.revokePlan.bind(this);
    this.changePlan = this.changePlan.bind(this);
    this.handleAffiliate = this.handleAffiliate.bind(this);
    this.createCoupon = this.createCoupon.bind(this);
    this.checkAffiliateId = this.checkAffiliateId.bind(this);
    this.onToggleOptionChange = this.onToggleOptionChange.bind(this);
  }

  componentDidMount() {
    this.checkAffiliateId();
    this.retriveInvoices();
    this.retriveTrackAccessOption();

    let privateSoundcastsUsageText = '';
    if (canUserAccessFeature('SOUNDCAST_PRIVATE')) {
      const limit = getUsageLimit('ALLOWED_SOUNDCAST_PRIVATE_SUBSCRIBERS');
      if (limit && limit < Number.MAX_VALUE) {
        const count = getUsageCurrent('private_subscribers');
        privateSoundcastsUsageText = `${count} subscribers enrolled (current plan limit: ${limit})`;
      }
    }

    this.setState({ privateSoundcastsUsageText });
  }

  componentWillReceiveProps(nextProps) {
    if (!isEqual(this.props.userInfo.publisher, nextProps.userInfo.publisher)) {
      this.checkAffiliateId(nextProps);
      this.retriveInvoices(nextProps);
    }
  }

  checkAffiliateId(props = {}) {
    const { userInfo } = isEmpty(props) ? this.props : props;
    const { couponText: couponCheck } = this.state;
    if (!isEmpty(couponCheck) || !has(userInfo, 'publisher.stripe_user_id')) {
      return;
    }

    couponsManager.getByAffiliate(userInfo.publisher.stripe_user_id)
      .then(couponText => {
        if (!isEmpty(couponText)) {
          // have coupon
          this.setState({ couponText });
        }
      })
      .catch(err => {
        console.log('error retrieving coupon by affiliate:', err.message);
      });
  }

  retriveInvoices(props = {}) {
    const {
      userInfo: { publisher = {} },
    } = isEmpty(props) ? this.props : props;

    if (!isEmpty(publisher)) {
      this.setState({ fetchInvoices: true }, () => {
        Axios.get(`/api/invoices/${publisher.id}`)
          .then(({ data: invoices }) => {
            invoices.sort((a, b) => b.created - a.created);
            this.setState({
              invoices,
              fetchInvoices: false,
            });
          })
          .catch(err => {
            console.log('error retrieving invoices: ', err);
            this.setState({
              fetchInvoices: false,
            });
          });
      });
    }
  }

  retriveTrackAccessOption() {
    this.setState({
      onlyMobileAccessToTracks: get(this.props, 'userInfo.publisher.onlyMobileAccessToTracks', false),
      disableTracksAttachedContent: get(this.props, 'userInfo.publisher.disableTracksAttachedContent', false),
    });
  }

  showAlertModal(metadata = {}) {
    this.alertDialog.showModal(metadata);
  }

  closeAlertModal() {
    this.alertDialog.closeModal();
  }

  async revokePlan() {
    try {
      this.closeAlertModal();
      const { userInfo } = this.props;
      const { id: publisherId, plan, current_period_end } = userInfo.publisher;
      const planName = plan.toUpperCase();
      await Axios.post('/api/cancel_plan', { publisherId });
      const endDate = moment.unix(current_period_end).format('MMM DD, YYYY');
      this.showAlertModal({
        content: `Your ${planName} plan auto renewal has been canceled. You still have access to ${planName} features till ${endDate}.`,
      });
      this.setState({ planCancelled: true });
    } catch (err) {
      this.showAlertModal({
        content:
          'There is an error canceling your subscription. Please contact Soundwise support at support@mysoundwise.com.',
      });
    }
  }

  changePlan() {
    const query = () => {
      const { userInfo } = this.props;
      const { created = null, referredBy = '' } = userInfo.publisher;

      // if reffered by partner, check for partner code attachments
      const isStarterPlan = isPublisherPlan('starter', userInfo.publisher);
      const isReffered = isPublisherReferredByPartner('stackcommerce', userInfo.publisher);
      const past = moment.unix(created);
      const isWithinValidDateRange = isWithinDaysRange(past, getPartnerCodesValidity());
      if (isStarterPlan && isReffered && isWithinValidDateRange) {
        const partnerCodes = getPartnerCodes(referredBy);
        return `?discount=${partnerCodes[0]}`;
      }

      return '';
    };

    this.props.history.push(`/pricing${query()}`);
  }

  handlePlanCancel() {
    const { userInfo } = this.props;
    if (userInfo.publisher) {
      const { plan } = userInfo.publisher;
      const planName = plan.toUpperCase();
      this.showAlertModal({
        content: `Are you sure you want to cancel your ${planName} subscription?`,
        actions: [
          <div className="padding-20px text-center">
            <ActionButton onClick={this.revokePlan}>Confirm</ActionButton>
            <ActionButton
              onClick={() => this.closeAlertModal()}
              textColor="#f76b1c"
              backgroundColor="#fff">
              Cancel
            </ActionButton>
          </div>,
        ],
      });
    }
  }

  async createCoupon(userName, stripe_user_id, count) {
    const couponText = (userName + (count || '')).toLowerCase();
    const coupon = await couponsManager.getByCode(couponText);
    if (!isNull(coupon)) {
      // coupon exist
      count++;
      this.createCoupon(userName, stripe_user_id, count); // recursion
    } else {
      await couponsManager.save(couponText, {
        count: 0,
        description: '30 Day Free',
        expiration: 4670449076,
        frequency: 'all',
        percentOff: 0,
        trialPeriod: 30,
        affiliate: stripe_user_id,
      });
      this.setState({ couponText });
    }
  }

  isRefferedByAppsumoStarter = () => {
    const { userInfo } = this.props;
    return (
      isPublisherPlan('starter', userInfo.publisher) &&
      isPublisherReferredByPartner('appsumo-starter', userInfo.publisher)
    );
  };

  async handleAffiliate() {
    // below code is deprecated
    const { userInfo } = this.props;
    if (!userInfo || !userInfo.publisher) {
      return this.showAlertModal({
        content: 'Invalid publisher data, please try again.',
      });
    }
    const { stripe_user_id } = userInfo.publisher;
    if (!stripe_user_id) {
      // If the publisher does not have a connected stripe payout account yet (stripe_user_id under the publisher node in firebase == null), the screen should alert user
      this.showAlertModal({
        content: 'Please connect your payout account first.',
      });
      // TODO redirect/show card input form (example client/containers/checkout.js)
    } else {
      // if the publisher has a stripe_user_id already, an affiliate id should be generated (use this format: affiliate id = [publisher id]-[stripe_user_id] of the referrer)
      this.createCoupon(userInfo.publisher.name.replace(/[^A-Za-z]/g, ''), stripe_user_id, 0);
      await publisherManager.saveProp(userInfo.publisherID, 'affiliate', true);
      this.setState({ affiliate: true });
    }
  }

  onToggleOptionChange(value = false, publisherPropName = null) {
    const publisherID = get(this, 'props.userInfo.publisherID');
    if (!isEmpty(publisherID) && !isEmpty(publisherPropName)) {
      const newValue = !value;
      publisherManager.saveProp(publisherID, publisherPropName, newValue)
       .then(() => {
         this.setState({ [publisherPropName]: newValue });
       })
       .catch(() => {
         this.showAlertModal({
           content: 'Unexpected save state error. Please try again later.',
         });
       });
    }
  }

  renderInvoiceBody() {
    const { invoices, fetchInvoices } = this.state;

    if (fetchInvoices) {
      return (
        <StatusContainer height={400} className="padding-40px-tb">
          <Loading text="Loading promotions" align="center" />
        </StatusContainer>
      );
    }

    if (isEmpty(invoices)) {
      return (
        <StatusContainer height={400} className="title-small padding-40px-tb">
          <span>There are no invoices to show.</span>
        </StatusContainer>
      );
    }

    return (
      <div className="table-wrapper table-responsive">
        <TableContainer>
          <InvoicesTable className="table table-hover">
            <thead>
              <tr>
                <th>Date</th>
                <th>Plan</th>
                <th>Payment Status</th>
                <th>Amount</th>
                <th>&nbsp;</th>
              </tr>
            </thead>
            <tbody>
              {invoices.map((invoice, i) => {
                const { amount, created, currency, invoice_pdf, description, status } = invoice;
                const idate = moment.unix(created).format('MMMM D, YYYY');
                return (
                  <tr key={`invoice-${i}`}>
                    <td className="padding-top-15px padding-bottom-15px">{idate}</td>
                    <td className="padding-top-15px padding-bottom-15px">{description}</td>
                    <td className="item-status padding-top-15px padding-bottom-15px">
                      <span className={status}>{ucfirst(status)}</span>
                    </td>
                    <td className="padding-top-15px padding-bottom-15px">
                      {`${currency} ${amount.paid || amount.due}`}
                    </td>
                    <td className="launch-icon padding-top-15px padding-bottom-15px">
                      <a href={invoice_pdf} target="_blank">
                        <i className="material-icons">launch</i>
                      </a>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </InvoicesTable>
        </TableContainer>
      </div>
    );
  }

  renderSubscriptionPlan() {
    const { userInfo } = this.props || {};
    const { publisher } = userInfo || {};
    const {
      planNameLong,
      planState,
    } = getPublisherPlanInfo(publisher);
    return (
      <>
        <div>
          <span className="plan-type text-large font-weight-600">
            {planNameLong}
          </span>
        </div>
        <div>
          <span>{planState}</span>
        </div>
      </>
    );
  }

  renderCancelPlanBtn() {
    const { planCancelled = false } = this.state || {};
    if (planCancelled) return null;

    const { userInfo = {} } = this.props || {};
    const { isAllowedCancelPlan = false } = getPlanStatus(userInfo.publisher);
    if (!isAllowedCancelPlan) return null;

    return (
      <OrangeSubmitButton
        label="Cancel Plan"
        onClick={this.handlePlanCancel}
        styles={{
          margin: '10px 0px 10px 10px',
          backgroundColor: 'transparent',
          color: Colors.mainOrange,
        }}
      />
    );
  }

  renderChangePlanBtn() {
    return (
      <OrangeSubmitButton
        label="Change Plan"
        onClick={this.changePlan}
        styles={{
          margin: '10px 0px',
          backgroundColor: Colors.link,
          border: 'none',
        }}
      />
    );
  }

  renderChangePlanWarning = () => {
    return (
      <a
        className="api-key-info"
        onClick={this.changePlan}
        title="This option is available on the PLATINUM plan.">
        <i
          className="material-icons"
          style={{ fontSize: 21, position: `relative`, paddingLeft: 3, top: 3 }}>
          info_outlined
        </i>
        <span 
          className="platinum-user" 
          style={{ marginLeft: -17 }}>
          PLATINUM
        </span>
      </a>
    );
  };

  render() {
    const {
      privateSoundcastsUsageText,
      onlyMobileAccessToTracks = false,
      disableTracksAttachedContent = false,
    } = this.state;
    const { userInfo } = this.props;

    if (!userInfo.publisher) {
      return (
        <LoadingWrapper height="70">
          <Loading text="Loading..." align="center" size={50} />
        </LoadingWrapper>
      );
    }

    const isFullAccess = !onlyMobileAccessToTracks;
    const accessToggle = {
      propName: 'onlyMobileAccessToTracks',
      title: 'Access for listeners to private or paid soundcasts',
      value: isFullAccess,
      text: isFullAccess
        ? 'Full access (from web and  mobile apps)'
        : 'Access only from mobile apps',
      disabled: !isPublisherPlan('platinum', userInfo.publisher),
    };

    const disableTracksAttachedContentToggle = {
      propName: 'disableTracksAttachedContent',
      title: 'Disable downloading of attached content from tracks',
      value: disableTracksAttachedContent,
      text: disableTracksAttachedContent
        ? 'Downloading of attached content are disabled for tracks'
        : 'Downloading of attached content are enabled for tracks',
      disabled: !isPublisherPlan('platinum', userInfo.publisher),
    };

    // linkminkAvailable, promotekitAvailable defined in /client/index.html

    return (
      <AccountWrapper>
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className="plan-details">
              <div className="plan-header text-large font-weight-600">Subscription Plan</div>
              {this.renderSubscriptionPlan()}
              <div className="plan-btns">
                {this.renderChangePlanBtn()}
                {this.renderCancelPlanBtn()}
              </div>
              {privateSoundcastsUsageText && (
                <div className="private-soundcasts text-large font-weight-600">
                  <div>
                    Private soundcasts usage
                    <div className="private-soundcasts-content font-weight-400">
                      {privateSoundcastsUsageText}
                    </div>
                  </div>
                </div>
              )}
              <div className="affiliate text-large font-weight-600">
                <div>
                  promotekit Affiliate Program
                  <a
                    className="api-key-info"
                    href={`${STATIC_HOMEPAGE_URL}/blog/how-to-become-a-soundwise-affiliate`}
                    target="_blank"
                    title="Learn more">
                    <i
                      className="material-icons"
                      style={{ fontSize: 21, position: `relative`, paddingLeft: 3, top: 3 }}>
                      info_outlined
                    </i>
                  </a>
                </div>
                <div>
                  {promotekitAvailable && (
                    <AffiliateBtn
                      className="text-medium font-weight-700 text-white"
                      title="Become An Affiliate"
                      href="https://soundwise.promotekit.com"
                      target="_blank">
                      Become An Affiliate
                    </AffiliateBtn>
                  )}
                  {!promotekitAvailable && (
                    <div className="alert alert-danger" role="alert">
                      sorry, affiliate program temporary unavailable...
                    </div>
                  )}
                </div>
              </div>

              {linkminkAvailable && (
              <div className="affiliate text-large font-weight-600">
                <div>
                  linkmink Affiliate Program
                  <a
                    className="api-key-info"
                    href={`${STATIC_HOMEPAGE_URL}/blog/how-to-become-a-soundwise-affiliate`}
                    target="_blank"
                    title="Learn more">
                    <i
                      className="material-icons"
                      style={{ fontSize: 21, position: `relative`, paddingLeft: 3, top: 3 }}>
                      info_outlined
                    </i>
                  </a>
                  (outdated)
                </div>
                <div>
                  {linkminkAvailable && (
                    <AffiliateBtn
                      className="text-medium font-weight-700 text-white"
                      title="Become An Affiliate"
                      href="https://app.linkmink.com/a/soundwise/403"
                      target="_blank">
                      Become An Affiliate
                    </AffiliateBtn>
                  )}
                  {!linkminkAvailable && (
                    <div className="alert alert-danger" role="alert">
                      sorry, affiliate program temporary unavailable...
                    </div>
                  )}
                </div>
              </div>
              )}

              <div className="affiliate text-large font-weight-600">
                <div className="margin-bottom-10px">
                  {accessToggle.title}
                  {accessToggle.disabled && this.renderChangePlanWarning()}
                </div>
                <div>
                  <ToggleWrapper>
                    <Toggle
                      disabled={accessToggle.disabled}
                      className="toggle-green"
                      aria-labelledby="toggle track-web-view"
                      checked={accessToggle.value}
                      onChange={() => this.onToggleOptionChange(
                        !accessToggle.value,
                        accessToggle.propName,
                      )}
                    />
                    <ToggleLabel className="text-large">{accessToggle.text}</ToggleLabel>
                  </ToggleWrapper>
                </div>
              </div>

              <div className="affiliate text-large font-weight-600">
                <div className="margin-bottom-10px">
                  {disableTracksAttachedContentToggle.title}
                  {disableTracksAttachedContentToggle.disabled && this.renderChangePlanWarning()}
                </div>
                <div>
                  <ToggleWrapper>
                    <Toggle
                      disabled={disableTracksAttachedContentToggle.disabled}
                      className="toggle-green"
                      aria-labelledby="toggle track-web-view"
                      checked={disableTracksAttachedContentToggle.value}
                      onChange={() => this.onToggleOptionChange(
                        disableTracksAttachedContentToggle.value,
                        disableTracksAttachedContentToggle.propName,
                      )}
                    />
                    <ToggleLabel className="text-large">{disableTracksAttachedContentToggle.text}</ToggleLabel>
                  </ToggleWrapper>
                </div>
              </div>

            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <InvoiceHeader>
              <span className="text-large font-weight-600">Payment History</span>
            </InvoiceHeader>
            {this.renderInvoiceBody()}
          </div>
        </div>
        <CustomDialog ref={ref => (this.alertDialog = ref)} />
      </AccountWrapper>
    );
  }
}

const AccountWrapper = styled.div`
  background-color: ${Colors.mainWhite};

  .plan-details {
    padding: 25px;

    .plan-header {
      margin-bottom: 20px;
    }

    .plan-type {
      color: ${Colors.mainOrange};
    }

    .plan-btns {
      display: flex;
    }
  }

  .private-soundcasts {
    padding-top: 20px;
    .private-soundcasts-content {
      padding-top: 10px;
    }
  }

  .affiliate {
    padding-top: 20px;

    .affiliate-links {
      padding: 10px 0;
    }
  }

  .platinum-user {
    font-size: 10px;
    font-weight: 800;
    color: red;
  }

  .table-wrapper {
    padding: 0 20px 20px;
  }
`;

const InvoiceHeader = styled.div`
  background: #fff;
  padding: 20px 24px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  border-bottom: 1px solid #eee;
`;

const InvoicesTable = styled(Table)`
  th {
    padding: 18px !important;
  }

  tr {
    border-bottom: 1px solid ${Colors.lightBorder};
  }

  td {
    padding: 18px !important;

    &.launch-icon {
      width: 24px;

      i {
        vertical-align: middle;
      }
    }

    &.item-status {
      > span {
        color: ${Colors.mainWhite};
        line-height: 1;
        white-space: nowrap;
        border-radius: 0.25em;
        font-size: 90%;
        font-weight: bold;
        display: inline;
        padding: 0.2em 0.6em 0.3em;

        &.draft {
          background-color: #555abf;
        }

        &.deleted {
          background-color: #e25950;
        }

        &.open {
          background-color: #3397d3;
        }

        &.paid {
          background-color: #24b47e;
        }

        &.uncollectible {
          background-color: #e2a049;
        }

        &.void {
          background-color: #b769c4;
        }
      }
    }
  }
`;

const AffiliateBtn = styled.a`
  width: 229px;
  display: inline-block;
  background-color: #4a4a4a;
  padding: 9px 20px;
  border-radius: 5px;
  letter-spacing: 1px;
  text-align: center;
  margin: 10px 0;
  word-spacing: 3px;
`;

export default Account;
